import { InputNumber } from "primereact/inputnumber";
import { MultiSelect } from "primereact/multiselect";
import { Checkbox } from "primereact/checkbox";

const EditMode = ({ defaultValues, setDefaultValues, t }: any) => {
    const days = [{ name: t("Mon"), value: "Mon" }, { name: t("Tue"), value: "Tue" }, { name: t("Wed"), value: "Wed" }, { name: t("Thu"), value: "Thu" }, { name: t("Fri"), value: "Fri" }, { name: t("Sat"), value: "Sat" }, { name: t("Sun"), value: "Sun" }];

    const onAlternateDaysCheckedChange = (e: any) => {
        setDefaultValues((prev: any) => ({
            ...prev,
            onAlternateDaysChecked: e.checked,
            days: e.checked ? [] : ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]
        }));
    }

    const onSetChange = (e: any) => {
        setDefaultValues((prev: any) => ({
            ...prev,
            set: e.value,
            restInterval: Math.floor(12 / e.value)
        }));
    }

    const setDaysValue = (value:any) => {
        setDefaultValues((prev:any) => ({
            ...prev,
            days: value
        }));
    }

    const setRepeatValue = (value:any) => {
        setDefaultValues((prev:any) => ({
            ...prev,
            repeat: value
        }));
    }

    const setToleranceValue = (value:any) => {
        setDefaultValues((prev:any) => ({
            ...prev,
            tolerance: value
        }));
    }

    return (
        <div className="flex flex-column gap-3">
            <div className="flex flex-column gap-2 align-items-start">
                <div className="flex">
                    <Checkbox name="label" onChange={onAlternateDaysCheckedChange} checked={defaultValues.onAlternateDaysChecked} />
                    <label htmlFor="label" className="ml-2">{t("onAlternateDays")}</label>
                </div>
                <InputNumber value={defaultValues.onAlternateDaysValue} disabled className=" w-full" />
            </div>
            <div className="flex flex-column gap-1">
                <label htmlFor="days" style={{ color: "#727A99" }}>{t("days")} <span style={{ color: "#E3506B" }}>*</span></label>
                <MultiSelect disabled={defaultValues.onAlternateDaysChecked} optionLabel="name" className="inline-flex justify-items-center align-items-center" value={defaultValues.days} options={days} display="chip" onChange={(e: any) => setDaysValue(e.value)} id="days" style={{ borderRadius: "10px", borderColor: "#9EA4B9", maxWidth: "100%", height: '3.5rem' }} />
            </div>
            <div className="flex flex-wrap gap-4">
                <div className="flex flex-grow-1 flex-wrap align-items-center gap-2 p-3 border-round-2xl" style={{ fontSize: '16px', color: "rgba(87, 97, 133, 1)", backgroundColor: "rgba(234, 235, 240, 1)" }}>
                    <span>{t('dailyFrequency')}</span>
                    <InputNumber
                        min={0}
                        max={75}
                        invalid={!defaultValues.set}
                        className="add-exercise-dialog-input-number inline-input"
                        value={defaultValues.set}
                        onChange={onSetChange}
                        inputId="set"
                        placeholder="0"
                        style={{
                            width: '3.125rem',
                            borderRadius: "10px"
                        }}
                    />
                    <span>{t('again')}</span>
                    <InputNumber
                        min={0}
                        max={60}
                        className="add-exercise-dialog-input-number inline-input"
                        disabled
                        value={defaultValues.restInterval}
                        inputId="restInterval"
                        placeholder="0"
                        style={{
                            width: '3.125rem',
                            borderRadius: "10px"
                        }}
                    />
                    <span>{t('hoursBreakWith')}</span>
                    <InputNumber
                        min={0}
                        max={30}
                        invalid={!defaultValues.repeat}
                        className="add-exercise-dialog-input-number inline-input"
                        value={defaultValues.repeat}
                        onValueChange={(e: any) => setRepeatValue(e.value)}
                        inputId="repeat"
                        placeholder="0"
                        style={{
                            width: '3.125rem',
                            borderRadius: "10px"
                        }}
                    />
                    <span>{t('repetitions')}.</span>
                </div>
                <div className="flex align-items-center gap-2" style={{ fontSize: '14px' }}>
                    <InputNumber
                        min={5}
                        max={75}
                        invalid={!defaultValues.tolerance}
                        className="add-exercise-dialog-input-number inline-input"
                        value={defaultValues.tolerance}
                        onValueChange={(e: any) => setToleranceValue(e.value)}
                        inputId="tolerance"
                        placeholder="0"
                        suffix="%"
                        style={{
                            width: '3.5rem',
                            borderRadius: "10px"
                        }}
                    />
                    <span>{t('tolerance')}</span>
                </div>
            </div>
        </div>
    )
}

export default EditMode;